<template>
  <div :class="['prestrainImg', prestrainClass]" v-bind:style="styleImgBox">
    <!-- <div class="loading-box" v-if="!isShow" :style="loadImgStyle">
      <loading-box text="图片加载中" />
    </div> -->
    <div class="img" v-if="!!isShow" v-bind:style="imgStyle"></div>
    <!-- <div class="img" v-else v-bind:style="imgStyle"></div> -->
    <slot name="child"> </slot>
  </div>
</template>

<script>
/*
 * prestrainImg: 图片预加载
 * 处理图片异常情况。补全缺损图
 * props{
 *   src: 图片链接
 *   imgWidth: 图片宽度，可传css兼容的所有样，如 100%，100px，100vw等
 *   HWProportion: 图片宽高比，可传百分比, 50%
 * }
 * by:bichaorui
 * */

// import loading from '@/components/common/loading.vue'

export default {
  name: 'prestrainImg',
  data() {
    return {
      styleImgBox: {
        width: this.imgWidth || '60px'
      },
      loadImgStyle: {
        'padding-top': this.HWProportion || '35%'
      },
      imgStyle: {
        'padding-top': this.HWProportion || '35%',
        'background-image': `url('${this.src}')`
        // 'background-image': 'url(' + this.src + ')'
        // width: this.imgWidth,
        // height: this.imgWidth
      },
      prestrainClass: this.imgClass || '',
      isShow: false
    }
  },
  // props: ['src', 'imgWidth', 'HWProportion', 'imgClass'],
  props: {
    src: String,
    imgWidth: String,
    HWProportion: String,
    imgClass: String
  },
  components: {
    // 'loading-box': loading
  },
  methods: {
    // load: ture/false
    isShowFun() {
      if (this.src) {
        var imgObj = document.createElement('img')
        imgObj.src = this.src
        // this.isShow = true

        // imgObj.onload = () => {
        this.isShow = true
        // }
      }
    }
  },
  mounted() {},
  created() {
    this.isShowFun()
  }
}
</script>
<style lang="scss">
.prestrainImg {
  display: inline-block;
  position: relative;
  width: 580px;
  z-index: 0;
  .img {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    padding-top: 100%;
  }
}
</style>
